import React, { useState } from 'react';
import './StarRating.css';

/**
 * StarRating — ดาวให้คะแนน
 * props:
 *   value     คะแนนปัจจุบัน (0-max)
 *   max       จำนวนดาว (ดีฟอลต์ 5)
 *   onChange  (n) => void  เรียกเมื่อคลิกดาว (เฉพาะโหมดแก้ไข)
 *   readOnly  true = แสดงอย่างเดียว กดไม่ได้
 *   size      ขนาดดาว (px)
 */
function StarRating({ value = 0, max = 5, onChange, readOnly = false, size = 28 }) {
    const [hover, setHover] = useState(0);
    const display = hover || value;

    return (
        <div
            className={`star-rating ${readOnly ? 'readonly' : ''}`}
            role="img"
            aria-label={`${value} จาก ${max} ดาว`}
        >
            {Array.from({ length: max }, (_, i) => i + 1).map((n) => (
                <button
                    type="button"
                    key={n}
                    className={`star-btn ${n <= display ? 'filled' : ''}`}
                    style={{ width: size, height: size }}
                    onMouseEnter={() => !readOnly && setHover(n)}
                    onMouseLeave={() => !readOnly && setHover(0)}
                    onClick={() => { if (!readOnly && onChange) onChange(n); }}
                    disabled={readOnly}
                    tabIndex={readOnly ? -1 : 0}
                    aria-label={`${n} ดาว`}
                >
                    <svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                </button>
            ))}
        </div>
    );
}

export default StarRating;
